import $ from 'jquery';
export default (props, e) => {
	e.preventDefault();
	if ($(e.target).closest('.nav-item').hasClass('opened')) {
		$('.header .nav-item.opened').removeClass('opened');
	} else {
		$('.header .nav-item').removeClass('opened');
		$(e.target).closest('.nav-item').addClass('opened');
		// $('#query').focus();
	}
};



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/webActions/headerNavDropdownHandler.js